module.exports = __webpack_public_path__ + "img/1233商品.d1706994.png";